var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgManHoldingKey = function SvgManHoldingKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 322.6 413.9",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.5 0a59.4 59.4 0 0 0-50.8 90.1L4.5 205.3l-.2.2-.2.2A14.9 14.9 0 0 0 25 227l.3-.3.5-.5 13-13L61.6 236l.7.7.3.3a14.9 14.9 0 1 0 19.6-22.4l-22.5-22.5 81.2-81.2A59.4 59.4 0 1 0 170.5 0zm0 91.9A32.5 32.5 0 1 1 203 59.4 32.5 32.5 0 0 1 170.5 92z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.6 152.9a14 14 0 0 0-22.5-11.4L231.4 194l-19 2.2 5.5 50.6-11 13.8-11.1-13.8 5.5-50.6-19-2.2-56.4-43-20.3 20.3 72.7 54.5V300l-29.2 92.8a14.6 14.6 0 0 0 26.1 13h.1l.2-.4a14.5 14.5 0 0 0 1.2-4l30.1-98.4 30.2 98.5a14.5 14.5 0 0 0 1.2 3.9l.2.5a14.6 14.6 0 0 0 26.2-13l-29.2-93v-74.4l81-61h.1l1.1-1a14 14 0 0 0 5-10.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 208.1,
    cy: 160.3,
    r: 28
  })));
};
export default SvgManHoldingKey;